var projectSettings = {
	inlineSVG: [
		'.footer__social img',
	]
};